<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 32 32"
    >
    <title>mediaicon</title>
    <path
          :fill="color"
           d="M16 2c7.732 0 14 6.268 14 14s-6.268 14-14 14S2 23.732 2 16 8.268 2 16 2m-3.338 8.798a1 1 0 0 0-.162.545v9.314a1 1 0 0 0 1.545.839l7.165-4.658a1 1 0 0 0 0-1.676l-7.165-4.658a1 1 0 0 0-1.383.294"/>
    </svg>
</template>
<script lang="ts" setup>
defineProps({
    color:{
        type:String,
        default:'currentColor'
    }
});

</script>

